import client from './client';

export const systemMessagesApi = () => client().get('/system-messages');

export const systemMessageApi = ({ id }) => client().get(`/system-messages/${id}`);

export const saveSystemMessageApi = ({ id, ...rest }) => client().put(`/system-messages/${id}`, rest);
